import React, { useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import TeachWithLogoPng from '../../../../Assets/teach-w-logo.png';
import ChooseCategory from './ChooseCategory';
import WebsiteURL from './WebsiteURL';
import DoYouHaveStore from './DoYouHaveStore';
import DoYouHaveECom from './DoYouHaveECom';
import PrimaryProduct from './PrimaryProduct';
import OtherProducts from './OtherProducts';
import DoYouAcceptPhone from './DoYouAcceptPhone';
import DoYouShip from './DoYouShip';
import DescribeBestCustomer from './DescribeBestCustomer';
import WhoAreYourCustomers from './WhoAreYourCustomers';
import ComfortableBudget from './ComfortableBudget';
import DavieAILogoWhite from '../../../../Assets/davieai-logo-white.png';
import { StyledButton } from '../../../../Components/Generics.styled';
import CircularProgress from '@mui/material/CircularProgress';

const LearnContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 1000px;
    max-width: 1200px;
    width: 100%;
`;

const TitleContainer = styled.div`
    justify-content: center;
    margin-top: 100px;
    display: flex;
    font-size: 36px;
    font-weight: 400px;
`;

const AppletContainer = styled.div`
    margin-top: 50px;
    width: 100%;
    /* min-width: 1200px; */
    height: 100%;
    max-height: 600px;
    /* border: 5px solid #2e69fe; */
    display: flex;
`;

const Column1 = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #2e69fe;
    width: 70%;
    /* min-width: 600px; */
    border: 5px solid #2e69fe;
    border-top-left-radius: 40px 40px;
    border-bottom-left-radius: 40px 40px;
    padding-left: 30px;
    padding-right: 30px;
`;

const Header = styled.div`
    color: white;
    margin-top: 50px;
    font-size: 66px;
`;

const SubHeader = styled.div`
    color: white;
    font-size: 36px;
    width: 100%;
    max-width: 400px;
    text-align: center;
`;

const Column2 = styled.div`
    width: 30%;
    /* min-width: 400px; */
    border: 5px solid #2e69fe;
    border-top-right-radius: 40px 40px;
    border-bottom-right-radius: 40px 40px;
`;

const ImageContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    display: flex;
    min-height: 400px;
`;

const DavieLogoContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    display: flex;
    margin-top: 100px;
`;

const Image = styled.img`
    object-fit: contain;
    width: 100%;
`;

const StyledProgressBar = styled.div`
    margin-top: 30px;
    width: 100%;
`;

const Circle = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;

    border: 1px solid white;
    background-color: #2e69fe;
    border-radius: 50%;
    color: white;
    margin-right: 10px;
`;

const CircleContainer = styled.div`
    display: flex;
    .dash-10 {
        display: none;
    }
`;

const QuestionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
    max-width: 850px;
    height: 160px;
    /* border: 1px solid white; */
`;

const FormFinishedContainer = styled.div`
    /* border: 1px solid white; */
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ThanksThatsGreat = styled.div`
    margin-top: 50px;
    color: #e0ff00;
    font-size: 36px;
    font-weight: 700;
`;

const NowGetDavie = styled.div`
    margin-top: 20px;
    color: #ffffff;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
`;

const CampaignStrategyBtn = styled(StyledButton)`
    border: 1px solid white;
    color: #e0ff00;
    max-width: unset;
    max-height: unset;
    font-size: 26px;
    border-radius: 8px;
    margin-top: 50px;
`;
const ConnectedLearn = ({
    teachDavieData,
    setTeachDavieData,
    useHistory,
    saveTeachDavieData,
    postData,
}) => {
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(0);

    const [progress] = useState([
        { pageIndex: 0, completed: false },
        { pageIndex: 1, completed: false },
        { pageIndex: 2, completed: false },
        { pageIndex: 3, completed: false },
        { pageIndex: 4, completed: false },
        { pageIndex: 5, completed: false },
        { pageIndex: 6, completed: false },
        { pageIndex: 7, completed: false },
        { pageIndex: 8, completed: false },
        { pageIndex: 9, completed: false },
        { pageIndex: 10, completed: false },
    ]);

    const handleNavButtonNext = () => {
        progress[currentPage].completed = true;
        setCurrentPage(currentPage + 1);
    };
    const handleNavButtonBack = () => {
        progress[currentPage].completed = false;
        progress[currentPage - 1].completed = false;

        setCurrentPage(currentPage - 1);
    };

    const ProgressBar = () => {
        return (
            <StyledProgressBar>
                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                    {progress.map((item, idx) => {
                        return (
                            <div key={idx + 1}>
                                <CircleContainer>
                                    <Circle
                                        style={
                                            item.completed
                                                ? { backgroundColor: '#2e69fe', color: 'white' }
                                                : { color: 'black', backgroundColor: 'white' }
                                        }
                                    >
                                        {idx + 1}
                                    </Circle>
                                    <div
                                        className={`dash-${idx}`}
                                        style={{
                                            color: 'white',
                                            fontSize: '24px',
                                        }}
                                    >
                                        -
                                    </div>
                                </CircleContainer>
                            </div>
                        );
                    })}
                </div>
            </StyledProgressBar>
        );
    };

    const RenderQuestion = () => {
        const determinePage = () => {
            switch (currentPage) {
                case 0:
                    return (
                        <WebsiteURL
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 1:
                    return (
                        <ChooseCategory
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 2:
                    return (
                        <DoYouHaveStore
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 3:
                    return (
                        <DoYouHaveECom
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 4:
                    return (
                        <PrimaryProduct
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 5:
                    return (
                        <OtherProducts
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 6:
                    return (
                        <DoYouAcceptPhone
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 7:
                    return (
                        <DoYouShip
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 8:
                    return (
                        <WhoAreYourCustomers
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 9:
                    return (
                        <DescribeBestCustomer
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
                case 10:
                    return (
                        <ComfortableBudget
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                            saveTeachDavieData={saveTeachDavieData}
                        />
                    );

                default:
                    return (
                        <WebsiteURL
                            handleNavButtonBack={handleNavButtonBack}
                            handleNavButtonNext={handleNavButtonNext}
                            teachDavieData={teachDavieData}
                            setTeachDavieData={setTeachDavieData}
                        />
                    );
            }
        };
        return <div>{determinePage()}</div>;
    };

    const handleSaveTeachDavie = async () => {
        await saveTeachDavieData();
        history.push('/portal/teach/campaignStrategy');
    };
    return (
        <LearnContainer>
            <TitleContainer>
                It&#39;s time to train your new
                <span style={{ color: '#2e69fe', fontWeight: 'bold', marginLeft: '10px' }}>ad</span>
                -<span style={{ fontWeight: 'bold' }}>visor</span>!
            </TitleContainer>
            <AppletContainer>
                <Column1>
                    {currentPage < 11 ? (
                        <>
                            <Header>To start,</Header>
                            <SubHeader>answer a few questions about your business: </SubHeader>
                            <ProgressBar />
                            <QuestionContainer>
                                <RenderQuestion />
                            </QuestionContainer>
                        </>
                    ) : (
                        <FormFinishedContainer>
                            <DavieLogoContainer>
                                <Image style={{ maxWidth: '400px' }} src={DavieAILogoWhite} />
                            </DavieLogoContainer>
                            <ThanksThatsGreat>Thanks - that&apos;s great!</ThanksThatsGreat>
                            <NowGetDavie>
                                Now get davie.ai recommendations for advertising your products and
                                services to your best customers!
                            </NowGetDavie>
                            <CampaignStrategyBtn onClick={() => handleSaveTeachDavie()}>
                                {postData.isLoading ? (
                                    <CircularProgress
                                        style={{ height: '20px', width: '20px', color: 'white' }}
                                        color="primary"
                                    />
                                ) : (
                                    'Click to get your Campaign Strategy'
                                )}
                            </CampaignStrategyBtn>
                        </FormFinishedContainer>
                    )}
                </Column1>
                <Column2>
                    <ImageContainer>
                        <Image src={TeachWithLogoPng} />
                    </ImageContainer>
                </Column2>
            </AppletContainer>
        </LearnContainer>
    );
};

ConnectedLearn.propTypes = {
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
    useHistory: propTypes.func,
    saveTeachDavieData: propTypes.func,
    postData: propTypes.shape({
        success: propTypes.bool,
        isLoading: propTypes.bool,
        error: propTypes.bool,
        message: propTypes.string,
    }),
};

ConnectedLearn.defaultProps = {};

export default ConnectedLearn;
